import { apiRequest } from '../cli-helpers.js';
import type {
  Envelope,
  WorkflowDebugRunDetail,
  WorkflowIdLookupResponse,
  WorkflowRunDetailResponse,
} from './types.js';

export function workflowDebugPath(workflowId: string, runId: string, subpath = ''): string {
  return `/workflows/${encodeURIComponent(workflowId)}/runs/${encodeURIComponent(runId)}/debug${subpath}`;
}

export async function lookupWorkflowIdForRun(
  apiUrl: string,
  token: string,
  runId: string
): Promise<WorkflowIdLookupResponse> {
  return apiRequest<WorkflowIdLookupResponse>(
    apiUrl,
    token,
    'GET',
    `/workflows/runs/${encodeURIComponent(runId)}/lookup`
  );
}

export async function fetchWorkflowDebug<T>(
  apiUrl: string,
  token: string,
  workflowId: string,
  runId: string,
  subpath = ''
): Promise<Envelope<T>> {
  return apiRequest<Envelope<T> & { ok: boolean; error?: string }>(
    apiUrl,
    token,
    'GET',
    workflowDebugPath(workflowId, runId, subpath)
  );
}

export function normalizeRunDetailResponse(
  res: WorkflowRunDetailResponse
): WorkflowDebugRunDetail | null {
  return res.data?.run ?? res.run ?? null;
}

export async function fetchWorkflowRunDetail(
  apiUrl: string,
  token: string,
  workflowId: string,
  runId: string
): Promise<{ run: WorkflowDebugRunDetail | null; error?: string }> {
  const res = await apiRequest<WorkflowRunDetailResponse & { ok: boolean }>(
    apiUrl,
    token,
    'GET',
    `/workflows/${encodeURIComponent(workflowId)}/runs/${encodeURIComponent(runId)}`
  );

  return {
    run: normalizeRunDetailResponse(res),
    error: res.error,
  };
}
